import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { icons } from '../../themes/icons';

interface PackageCardProps {
  bgColor: string;
  label: string;
  count?: string;
  comparison?: number;
  substr?: string;
  isMobile?: boolean;
  showFooter?: boolean;
  newCount?: number;
  canceledCount?: number;
  showComparison?: boolean;
  selectedLabel?: string;
  link?: string;
}

export const PackageCard: React.FC<PackageCardProps> = ({
  label,
  count,
  comparison = 0,
  substr = '',
  isMobile = false,
  showFooter = false,
  newCount,
  canceledCount,
  showComparison = false,
  selectedLabel,
  link,
}) => {
  const boxComponent = (
    <ActiveModals>
      <Heading>
        {label}
        {label?.includes('Starter') ? (
          <icons.StarterHatIcon />
        ) : label === 'Plus' ? (
          <icons.PremiumHatIcon />
        ) : label === 'Premium models' ? (
          <icons.PremiumHatIcon />
        ) : null}
        {label === 'Premium models' ? 'and Scouting sub.' : null}
      </Heading>
      {isMobile ? (
        <>
          <Count>
            {count}
            {substr && <span>{`(${substr})`}</span>}
          </Count>
          {showComparison && (
            <Comparison value={comparison}>{`${
              comparison >= 0 ? '+' : ''
            } ${comparison}% ${selectedLabel}`}</Comparison>
          )}
        </>
      ) : (
        <DesktopCardData>
          <Count>
            {count}
            {substr && <span>{`(${substr})`}</span>}
          </Count>
          {showComparison && (
            <Comparison value={comparison}>{`${
              comparison >= 0 ? '+' : ''
            } ${comparison}% ${selectedLabel}`}</Comparison>
          )}
        </DesktopCardData>
      )}
      {showFooter && (
        <FooterContainer>
          <ValueContainer>
            <FooterLabel>New</FooterLabel>
            <FooterValue>{newCount}</FooterValue>
          </ValueContainer>
          <ValueContainer>
            <FooterLabel>Canceled</FooterLabel>
            <FooterValue>{canceledCount}</FooterValue>
          </ValueContainer>
        </FooterContainer>
      )}
    </ActiveModals>
  );

  return (
    <>
      {link ? (
        <Link to={link} style={{ color: 'inherit', textDecoration: 'none', width: '100%' }}>
          {boxComponent}
        </Link>
      ) : (
        boxComponent
      )}
    </>
  );
};

const ActiveModals = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  width: 100%;
`;

const Heading = styled.span`
  color: #111111;
  font-size: 13px;
  font-family: Poppins;
  font-weight: 400;
  word-wrap: break-word;
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Count = styled.p`
  color: #111111;
  font-size: 36px;
  font-family: Poppins;
  font-weight: 500;
  word-wrap: break-word;
  line-height: 18px;
  margin: 20px 0 8px 0;

  span {
    font-size: 15px;
    font-family: Poppins;
    font-weight: 600;
    line-height: 18px;
    word-wrap: break-word;
    margin-left: 8px;
  }
`;

const Comparison = styled.span<{ value: number }>`
  color: ${({ value }) => (value > 0 ? '#408155' : value < 0 ? '#BC3438' : 'rgba(0, 0, 0, 0.50)')};
  font-size: 13px;
  font-family: Poppins;
  font-weight: 400;
  word-wrap: break-word;
  line-height: 18px;
`;

const DesktopCardData = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
`;

const FooterContainer = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  font-size: 13px;
  margin-top: 5px;
`;

const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const FooterLabel = styled.span`
  display: inline-block;
  font-weight: 400;
`;

const FooterValue = styled.span`
  display: inline-block;
  font-weight: 500;
`;
